import {useState} from 'react';
import {Alert, Button, Grid, TextField, Typography} from '@mui/material';
import {Form, useActionData, useLoaderData, useNavigation} from 'react-router-dom';
import api from '../../hooks/useApi';
import PasswordField from '../../components/PasswordField';
import PageTitle from '../../components/PageTitle';

export async function action({request}) {
    const payload = Object.fromEntries((await request.formData()).entries());
    if (payload.password !== payload.password_confirm) return {status: 400, error: 'Паролі не збігаються'};
    try {
        const response = await api.post('/api/admin/mailboxes/', payload);
        return {status: 'success', address: response.data.address};
    } catch (error) {
        return {status: error.response?.status || 500, error: error.response?.data?.detail || 'Помилка створення пошти'};
    }
}

export async function loader() {
    const response = await api.get('/api/admin/mailboxes/');
    return response.data;
}

export default function NewMail() {
    const result = useActionData();
    const {domain = 'easyrentplace.com'} = useLoaderData();
    const navigation = useNavigation();
    const [username, setUsername] = useState('');
    const [passwords, setPasswords] = useState({password: '', password_confirm: ''});
    const setGeneratedPassword = (value) => setPasswords({password: value, password_confirm: value});
    const address = username ? `${username}@${domain}` : `username@${domain}`;
    return <Grid container spacing={2} component={Form} method="post" sx={{p: 2}}>
        <Grid item xs={12}><PageTitle title="Створення пошти"/><Typography>{address}</Typography></Grid>
        {result?.status === 'success' ? <Grid item xs={12}><Alert severity="success">Створено: {result.address}</Alert></Grid> : <>
            {result?.error && <Grid item xs={12}><Alert severity="error">{result.error}</Alert></Grid>}
            <Grid item xs={12}><TextField required fullWidth name="username" label="Ім’я користувача" value={username} onChange={e => setUsername(e.target.value.toLowerCase())} inputProps={{pattern: '[a-z][a-z0-9]{0,31}'}} /></Grid>
            <Grid item xs={12} md={6}><PasswordField required name="password" label="Пароль" value={passwords.password} onChange={value => setPasswords(p => ({...p, password: value}))} onGenerate={setGeneratedPassword} /></Grid>
            <Grid item xs={12} md={6}><PasswordField required name="password_confirm" label="Підтвердження пароля" value={passwords.password_confirm} onChange={value => setPasswords(p => ({...p, password_confirm: value}))} onGenerate={setGeneratedPassword} /></Grid>
            <Grid item xs={12}><Button type="submit" variant="contained" disabled={navigation.state === 'submitting'}>Створити пошту</Button></Grid>
        </>}
    </Grid>;
}